export const formattedSeconds = (seconds: number): string => {
  const value = Math.max(seconds, 0);
  const minutes = Math.floor(value / 60);
  const rem = value % 60;
  return `${minutes}:${rem < 10 ? 0 : ""}${Math.floor(rem)}`;
};

export const remainingDaysCount = (from: Date) => {
  const result = Math.floor(
    (from.getTime() - Date.now()) / (24 * 60 * 60 * 1000)
  );
  return result;
};

export function toAge(birthdate: string) {
  var birthday = +new Date(birthdate);
  return ~~((Date.now() - birthday) / 31557600000);
}

export const toDateTimeString = (date: Date) =>
  `${date.getFullYear()}-${(date.getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")} ${date
    .getHours()
    .toString()
    .padStart(2, "0")}:${date.getMinutes().toString().padStart(2, "0")}:${date
    .getSeconds()
    .toString()
    .padStart(2, "0")}`;

export const toTime = (datetime: string) => {
  return datetime.split(" ")[1].split(":").slice(0, 2).join(":");
};

const monthName = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const toDate = (datetime: string) => {
  const monthAndDay = datetime.split(" ")[0].split("-").slice(1, 3);
  return monthName[parseInt(monthAndDay[0]) - 1] + " " + monthAndDay[1];
};
